import { Link } from 'react-router-dom';

interface FooterProps {
  showAdvertorialDisclaimer?: boolean;
}

export default function Footer({ showAdvertorialDisclaimer = false }: FooterProps) {
  return (
    <footer className="bg-gray-900 text-white py-8 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="bg-orange-600 rounded-lg px-6 py-4 mb-6 text-center">
          <p className="text-white text-sm font-medium">
            Hinweis: Nur die ersten 100 Teilnehmer erhalten den Aktionspreis. Danach kostet das Programm 149 €.
          </p>
        </div>

        {showAdvertorialDisclaimer && (
          <div className="bg-gray-800 rounded-lg px-6 py-4 mb-6">
            <p className="text-xs text-gray-300 leading-relaxed">
              <span className="font-semibold text-white">Werbehinweis:</span> Bei diesem Beitrag handelt es sich um einen werblichen Advertorial-Artikel, der in Zusammenarbeit mit einem werbenden Unternehmen erstellt wurde. Die dargestellten Inhalte und Meinungen spiegeln die Sicht des Werbetreibenden wider und stellen keine redaktionelle Empfehlung dar. Alle Angaben erfolgen ohne Gewähr. Die beschriebenen Ergebnisse sind Einzelerfahrungen und können individuell abweichen – eine Garantie für bestimmte Erfolge oder Ergebnisse wird nicht gegeben. Jede Haftung für Schäden, die direkt oder indirekt aus der Nutzung der bereitgestellten Informationen entstehen, wird ausgeschlossen.
            </p>
          </div>
        )}

        <div className="mb-6 px-6 py-4">
          <p className="text-xs text-gray-400 leading-relaxed">
            <span className="font-semibold">Wichtiger Hinweis:</span> Dieses Produkt ist <span className="font-semibold">nicht dazu bestimmt</span>, Krankheiten zu diagnostizieren, zu behandeln, zu heilen oder zu verhindern. Die hier bereitgestellten Informationen dienen ausschließlich <span className="font-semibold">zu Informationszwecken</span> und ersetzen <span className="font-semibold">keine ärztliche Beratung oder Behandlung</span>.
            <br /><br />
            Bevor Sie mit einer Diät, einem Trainings- oder Nahrungsergänzungsprogramm beginnen, sollten Sie sich von einem Arzt oder einem anderen qualifizierten Gesundheitsdienstleister beraten lassen.
            <br /><br />
            Ergebnisse beim Abnehmen können variieren. Typischerweise verlieren Konsumenten 0,5–1 kg pro Woche im Rahmen einer kalorienreduzierten Ernährung und Bewegung.
            <br /><br />
            Zur besseren Darstellung können auf dieser Seite <span className="font-semibold">KI-generierte Inhalte und Szenarien</span> verwendet werden, die nicht in allen Fällen real sind.
            <br /><br />
            Die individuelle Wirkung kann variieren.
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Christel Media Marketing GmbH. Alle Rechte vorbehalten.
          </p>

          <div className="flex gap-6">
            <Link
              to="/impressum"
              className="text-gray-400 hover:text-white transition-colors text-sm"
            >
              Impressum
            </Link>
            <Link
              to="/datenschutz"
              className="text-gray-400 hover:text-white transition-colors text-sm"
            >
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
